<div id="user-display" *ngIf="isLogged()" class="btn" (click)="toggleDropdown()">
    <i class="fa fa-user-circle" style="font-size: 2em;"></i> {{username()}}
</div>
<div class="dropdown" [class.open]="isOpen()">
    <a id="logout" (click)="logout()" *ngIf="isLogged()" class="btn">Sign out</a>
</div>
